import { useCmrServiceCmrDirectionsList } from '@insurance/api/queries'
import { useValidationsField } from '@insurance/hooks'
import {
  Col,
  DatePicker,
  Form,
  InputNumber,
  Row,
  Select,
  Typography
} from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

const { Title } = Typography

// Default destinations to pre-select on a new CMR: European Union + CIS (CSI)
// countries.
const DEFAULT_DESTINATION_CODES = ['EU', 'CIS']

export const TransportActivity = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const form = Form.useFormInstance()

  const {
    contractorActivitySinceProps,
    destinationsProps,
    tripsPerVehicleProps,
    generalCargoTypesProps
  } = formProps(t)

  const { data: directions = [] } = useCmrServiceCmrDirectionsList({})

  const destinationOptions = directions.map((d) => ({
    label: d.name,
    value: d.code
  }))

  useEffect(() => {
    if (!directions.length) return

    const current = form.getFieldValue(destinationsProps.name)
    if (current?.length) return

    const defaultCodes = directions
      .filter((d) => DEFAULT_DESTINATION_CODES.includes(d.code))
      .map((d) => d.code)

    if (defaultCodes.length) {
      form.setFieldValue(destinationsProps.name, defaultCodes)
    }
  }, [directions, form, destinationsProps.name])

  return (
    <>
      <Title level={5}>{t('cmr_transport_activity')}</Title>

      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <Form.Item {...contractorActivitySinceProps} rules={[required]}>
            <DatePicker.YearPicker
              maxDate={dayjs()}
              placeholder={contractorActivitySinceProps.label}
              className="w-full"
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item {...destinationsProps} rules={[required]}>
        <Select
          mode="multiple"
          placeholder={destinationsProps.label}
          options={destinationOptions}
          allowClear
        />
      </Form.Item>

      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...tripsPerVehicleProps} rules={[required]}>
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              precision={0}
              placeholder={tripsPerVehicleProps.label}
            />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...generalCargoTypesProps} rules={[required]}>
            <Select
              mode="tags"
              placeholder={generalCargoTypesProps.label}
              allowClear
              open={false}
              suffixIcon={null}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
